import type { FaireProductEntity } from "../../entity_types/product";

export const p_t7yvn37bwu: FaireProductEntity = {
  token: "p_t7yvn37bwu",
  type: "product",
  name: "Spring Bow Dot Denim Ruffle Top and Pants Set 3/4 Pants",
  brandToken: "b_xvvfvktx6s",
  brandName: "Rylee Faith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/8fcad77e487763c4223818184615168e13dbcf31c48da8488ea014cb5607256d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1881e71a82a83aa0d4c45787755ac58f2fa9d6b78ea597fc5fd1c9b1b904b272.jpeg",
    "https://cdn.faire.com/fastly/6c6c57e20c09cd3b727695c20b2deb50f51d1bce2ad6a029306e271f0a139e45.jpeg",
    "https://cdn.faire.com/fastly/d106fa80d54877ef82d9fdfd242f2c47b76fa9269159e7fe6f13a0217707a56d.jpeg",
    "https://cdn.faire.com/fastly/554ed39118ca7709ae4d0eb8843bc0a00ddb4ca0ec118300d2eda1d6dd32b636.jpeg",
    "https://cdn.faire.com/fastly/5683343246cadc95d72d44adee4089e6a5d1d82794b4f662a837f89f5b74e094.jpeg",
  ],
  priceDollars: 17.99,
  description:
    "This charming two-piece set will make your little one shine this spring. The soft denim ruffled top, adorned with playful polka dots and bow prints, is paired with comfortable and stylish jeans, making it perfect for playtime, family outings, or everyday casual wear. The excellent craftsmanship ensures durability and prevents deformation even after multiple washes. The classic denim fabric complements the sweet, feminine design, making this set a versatile must-have. Seeing your child radiant in this outfit that blends classic charm with modern flair—you'll love it and want to find the perfect clothes for her again and again.\n\nMaterial:90% cotton, 10% polyester\n\nBlue SKU: OFG54252\nPink SKU:OFG62302\n\n\n",
  tags: [],
  msrpDollars: 35.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:59.110Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
